import createCache  from '@emotion/cache';
import { prefixer } from 'stylis';
import stylisRTLPlugin from 'stylis-plugin-rtl';

export const createRTLCache = (isRTL: boolean) => {
    return createCache({
        key: isRTL ? 'mui-rtl' : 'mui-ltr',
        stylisPlugins: isRTL ? [prefixer, stylisRTLPlugin] : [prefixer],
    });
};